import { Component, OnInit } from '@angular/core';
import { SignupStepperService } from '@app/modules/signup-new/services/signup-stepper.service';
import { SignupUserService } from '@app/modules/signup-new/services/signup-user.service';
import { SignupWizardService } from '@app/modules/signup-new/services/signup-wizard.service';
import { SignupChannel, SignupChannelWrapper } from '@app/modules/user/signup/signup.interface';
import { finalize } from 'rxjs/operators';

const lowPropertiesUrl =
  'https://meetings.hubspot.com/vkovacevic/ae-full-team-roundrobin-3-40?utm_campaign=SignUpFlow&utm_source=SignupFlow&utm_medium=SignupFlow';
const highPropertiesUrl =
  'https://meetings.hubspot.com/ebekus/ae-enteprise-link-ewelina?utm_campaign=SignUpFlow&utm_source=SignupFlow&utm_medium=SignupFlow';
const propertiesLimit = 40;

@Component({
  selector: 'sbnb-signup-channels-page',
  templateUrl: './signup-channels-page.component.html',
})
export class SignupChannelsPageComponent implements OnInit {
  channels: SignupChannelWrapper[] = [
    { key: SignupChannel.Airbnb, enabled: false, label: 'Airbnb', asset: 'airbnb-white.svg' },
    { key: SignupChannel.Vrbo, enabled: false, label: 'Vrbo', asset: 'homeaway-white.svg' },
    { key: SignupChannel.BookingDotCom, enabled: false, label: 'Booking.com', asset: 'booking.svg' },
    { key: SignupChannel.Direct, enabled: false, label: 'Direct booking website', asset: 'direct.svg' },
    { key: SignupChannel.Agoda, enabled: false, label: 'Agoda', asset: 'agoda.svg' },
    { key: SignupChannel.Other, enabled: false, label: 'Other' },
  ];
  atLeastOneChannelEnabled = false;
  notListedChecked = false;
  isSaving = false;
  propertyCount = 0;

  constructor(
    private signupWizardService: SignupWizardService,
    private signupStepperService: SignupStepperService,
    public signupUserService: SignupUserService
  ) {}

  ngOnInit() {
    this.toggleChannel(SignupChannel.Airbnb, this.signupUserService.isAirbnbSignup);
    this.propertyCount = this.signupUserService.user$.value?.property_count || 0;
  }

  onContinue() {
    if (!this.notListedChecked && !this.atLeastOneChannelEnabled) return;

    this.isSaving = true;
    this.signupUserService
      .updatePlatforms(this.channels.filter((c) => c.enabled).map((c) => c.key))
      .pipe(finalize(() => (this.isSaving = false)))
      .subscribe(() => {
        this.signupWizardService.next('channels');
        this.signupStepperService.complete('Properties');
      });
  }

  onBookDemo() {
    window.open(this.propertyCount > propertiesLimit ? highPropertiesUrl : lowPropertiesUrl, '_blank');
  }

  toggleChannel(key: SignupChannel, forcedValue?: boolean) {
    const channel = this.channels.find((channel) => channel.key === key);

    const newValue = forcedValue !== undefined ? forcedValue : !channel.enabled;
    if (channel) channel.enabled = newValue;

    // If at least one channel is enabled, then not listed should be disabled
    if (newValue) this.notListedChecked = false;

    this.atLeastOneChannelEnabled = this.channels.some((channel) => channel.enabled);
  }

  toggleNotListed() {
    const newValue = !this.notListedChecked;
    this.notListedChecked = newValue;

    // If not listed is checked, then all channels should be disabled
    if (newValue) this.channels.forEach((channel) => (channel.enabled = false));
  }
}
